import GER from '../assets/img/aleman.jpg';
import ESP from '../assets/img/espanol_mx.jpg';
import FRA from '../assets/img/frances.jpg';
import ING from '../assets/img/ingles_usa.jpg';
import ITA from '../assets/img/italiano.jpg';
import POR from '../assets/img/portugues.jpg';

// Flag ID ranges
// English: 15-17, 34
// Spanish: 18-20
// French: 21-23
// Portuguese: 24-26
// German: 27-29
// Italian: 30-32
// Special: 33, 35

export function selectFlagFile(flag) {
  // Legacy support for old IDs
  switch(flag) {
    case 1:
      return ING;
    case 2:
      return ESP;
    case 3:
      return FRA;
    case 4:
      return GER;
    case 5:
      return ITA;
    case 6:
      return POR;
    default:
      break;
  }

  // New catalog IDs
  if ((flag >= 15 && flag <= 17) || flag === 34) return ING;  // English (all levels + Chedraui)
  if (flag >= 18 && flag <= 20) return ESP;                   // Spanish (all levels)
  if (flag >= 21 && flag <= 23) return FRA;                   // French (all levels)
  if (flag >= 24 && flag <= 26) return POR;                   // Portuguese (all levels)
  if (flag >= 27 && flag <= 29) return GER;                   // German (all levels)
  if (flag >= 30 && flag <= 32) return ITA;                   // Italian (all levels)
  
  // Special cases and default
  if (flag === 33 || flag === 35) return ESP;                 // Workshops and B2C default to Spanish flag
  return ESP;                                                 // Default to Spanish flag
}